import React, { CSSProperties, FC, ReactNode } from 'react';

import styled from 'styled-components';

import { Box } from '@mui/material';

import { themes } from '../../../../consts/experiences';
import { Spacing, margin, padding } from '../../helpers';

// TODO: Use BoxProps instead. Replace usage.
type FlexProps = {
  align?: string;
  justify?: string;
  direction?: string;
  style?: CSSProperties;
  children?: ReactNode;
} & Spacing;

type GridProps = {
  rows?: string;
  columns: string;
  rowGap?: string;
  justify?: string;
  align?: 'baseline' | 'center' | 'end' | 'flex-end' | 'flex-start' | 'inherit' | 'initial' | 'normal' | 'unset';
  columnGap?: string;
  height?: string;
  children?: ReactNode;
} & Spacing;

export const FlexWrapper = styled((props: FlexProps) => <Box component="div" {...props} />)<FlexProps>`
  width: 100%;
  display: flex;

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};

  align-items: ${({ align }) => align || 'center'};
  justify-content: ${({ justify }) => justify || 'unset'};
  flex-direction: ${({ direction }) => direction || 'row'};
` as FC<FlexProps>;

export const GridWrapper = styled.div<GridProps>`
  height: ${({ height }) => height};
  width: 100%;
  display: grid;

  row-gap: ${({ rowGap }) => rowGap || '0px'};
  grid-template-rows: ${({ rows }) => rows || ''};
  column-gap: ${({ columnGap }) => columnGap || '0px'};
  justify-items: ${({ justify }) => justify || 'center'};
  align-items: ${({ align }) => align || 'inherit'};
  grid-template-columns: ${({ columns }) => columns || 'repeat(2, 1fr)'};

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<GridProps>;

export const LineDivisor = styled.div<Spacing>`
  height: 25px;
  border-right: 1px solid ${themes?.secondaryGrey};

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<Spacing>;

export const LineHorizontalDivisor = styled.div<Spacing>`
  width: 100%;
  border-bottom: 1px solid ${themes?.secondaryGrey};

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<Spacing>;

export const Wrapper = styled.div<Spacing>`
  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<Spacing>;
